import Row from 'models/listing/Row';

class DataRow extends Row {
    initRowLevel(){
        this.set('row_level', 0);
    }
}

export default DataRow;